import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

i18n.use(
    new Backend(undefined, { loadPath: '/locales/{{lng}}/translation.json?v1' })
)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        lng: 'en-us',
        fallbackLng: 'en-us', // use en if detected lng is not available
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
        react: {
            useSuspense: false,
        },
    });

export default i18n;
